import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {animateShow} from "../../animations/showHideAnimation";
import {MultiSelectItemsService} from "../../services/multiSelectItemsService/multi-select-items.service";
import {DomEventsService} from "../../services/dom-event-services/dom-events.service";
import {isViewMode, isViewModeByShareLink} from '@src/configs/view_only';
import {filter} from "rxjs/operators";

@Component({
  selector: 'app-multiselect-top-group',
  templateUrl: './multiselect-top-group.component.html',
  styleUrls: ['./multiselect-top-group.component.scss'],
  animations: [animateShow]
})
export class MultiselectTopGroupComponent extends AbstractObserver implements OnInit {


  @ViewChild('element', {static: false}) element;
  public isGroupActionsVisible = false;
  public isMultiSelectMoveAvailable = false;
  public isGroupListVisible = false;
  public disabled = isViewMode || isViewModeByShareLink;
  private selectedItemsByMultiSelect = {};

  //private gs: GroupService,
  constructor(private cd: ChangeDetectorRef, private im: ItemManagerService, private cs: ConcreteLayerService, private ms: MultiSelectItemsService, private domEvents: DomEventsService) {
    super();
    this.subscribeToObservable(this.im.selectedItemList$, (config)=>{
      this.isMultiSelectMoveAvailable = Object.keys(config).length > 0;
      this.selectedItemsByMultiSelect = config;
      this.cd.detectChanges();
    })
    this.subscribeToObservable(this.domEvents.sidebarState$.pipe(filter(val=> !val && (this.isGroupActionsVisible || this.isGroupListVisible))), (val)=>{
      this.isGroupActionsVisible = false;
      this.isGroupListVisible = false;
      this.domEvents.currentActiveAdditionalMenuElement = null;
      this.cd.detectChanges();
    });

    // @ts-ignore
    this.subscribeToObservable(this.domEvents.currentHiddenMenuUpdated$.pipe(filter(value => { return value.type !== 'multiselect'})), ()=>{
      this.isGroupActionsVisible = false;
      this.cd.detectChanges();
    })
  }

  moveToNewFloorplan(){
    this.ms.multiSelectMethod = 'move';
    this.isGroupActionsVisible = false;
    this.isGroupListVisible = false;
    this.ms.openFloorplanModal();
    this.cd.detectChanges();
  }

  copyToNewFloorplan(){
    this.ms.multiSelectMethod = 'copy';
    this.isGroupActionsVisible = false;
    this.isGroupListVisible = false;
    this.ms.openFloorplanModal();
    this.cd.detectChanges();
  }


  // getAllGroups(){
  //   let gList = this.gs.groupList.slice(0);
  //   gList = gList.filter((group)=>{
  //     return group.getFloorPlanId() == this.cs.selectedConcrete.id;
  //   });
  //   return gList;
  // }
  //
  // hasAnotherGroup(){
  //   let gList = this.gs.groupList.slice(0);
  //   return gList.filter((group)=>{
  //     return group.getFloorPlanId() == this.cs.selectedConcrete.id;
  //   }).length > 1;
  // }

  toggleGroupActionsVisibility(){
    if (this.disabled) { return; }

    this.isGroupActionsVisible = !this.isGroupActionsVisible;
    if (this.isGroupActionsVisible){
      this.domEvents.currentHiddenMenuUpdated$ = {type: 'multiselect', item: null};
      this.cd.detectChanges();
      this.domEvents.currentActiveAdditionalMenuElement = this.element;
    }
    else{
      this.domEvents.currentActiveAdditionalMenuElement = null;
    }
    this.cd.detectChanges();
  }

  // public moveToGroup(group){
  //   if (!this.isMultiSelectMoveAvailable){
  //     return;
  //   }
  //   for (let i in this.selectedItemsByMultiSelect){
  //     let _item = this.selectedItemsByMultiSelect[i];
  //     this.gs.moveToNewGroup(_item, group);
  //   }
  //   this.isGroupListVisible = false;
  //   this.cd.detectChanges()
  // }

/*   setGroupListVisibility(val: boolean){
    this.isGroupListVisible = val;
    this.cd.detectChanges();
  } */

  ngOnInit() {
  }

}
